import { comparePageValidationObject } from './comparePageValidationSchema';
import { date, object, string } from 'yup';
import { getDateFourteenDaysFromNow } from './getDateFourteenDaysFromNow';

const minDate = getDateFourteenDaysFromNow();

export const fastTrackValidationObject = {
  ...comparePageValidationObject,
  plannedClosingDate: date().required().min(minDate, 'date must be at least 15 days in the future'),
  lookingTo: string().required(),
}

export const fastTrackValidationSchema = object(fastTrackValidationObject);
